import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=974cc36c&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=ts"
export * from "./Blog.vue?vue&type=script&lang=ts"
import style0 from "./Blog.vue?vue&type=style&index=0&id=974cc36c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974cc36c",
  null
  
)

export default component.exports